import {
  FETCH_CSV_IMPORT_LOGS_REQUEST,
  FETCH_CSV_IMPORT_LOGS_SUCCESS,
  FETCH_CSV_IMPORT_LOGS_FAILURE,
  FETCH_ACTIVE_CSV_IMPORT_LOGS_REQUEST,
  FETCH_ACTIVE_CSV_IMPORT_LOGS_SUCCESS,
  FETCH_ACTIVE_CSV_IMPORT_LOGS_FAILURE,
  FETCH_CSV_IMPORT_LOG_BY_ID_REQUEST,
  FETCH_CSV_IMPORT_LOG_BY_ID_SUCCESS,
  FETCH_CSV_IMPORT_LOG_BY_ID_FAILURE,
  FETCH_CSV_IMPORT_LOG_BY_REFERENCE_REQUEST,
  FETCH_CSV_IMPORT_LOG_BY_REFERENCE_SUCCESS,
  FETCH_CSV_IMPORT_LOG_BY_REFERENCE_FAILURE,
  CREATE_CSV_IMPORT_LOG_REQUEST,
  CREATE_CSV_IMPORT_LOG_SUCCESS,
  CREATE_CSV_IMPORT_LOG_FAILURE,
  UPDATE_CSV_IMPORT_LOG_REQUEST,
  UPDATE_CSV_IMPORT_LOG_SUCCESS,
  UPDATE_CSV_IMPORT_LOG_FAILURE,
  UPDATE_CSV_IMPORT_LOG_CONFIRMATION_REQUEST,
  UPDATE_CSV_IMPORT_LOG_CONFIRMATION_SUCCESS,
  UPDATE_CSV_IMPORT_LOG_CONFIRMATION_FAILURE,
  DELETE_CSV_IMPORT_LOG_REQUEST,
  DELETE_CSV_IMPORT_LOG_SUCCESS,
  DELETE_CSV_IMPORT_LOG_FAILURE,
  FETCH_CSV_IMPORT_LOGS_STATS_REQUEST,
  FETCH_CSV_IMPORT_LOGS_STATS_SUCCESS,
  FETCH_CSV_IMPORT_LOGS_STATS_FAILURE,
  FETCH_CSV_IMPORT_LOGS_BY_DATE_RANGE_REQUEST,
  FETCH_CSV_IMPORT_LOGS_BY_DATE_RANGE_SUCCESS,
  FETCH_CSV_IMPORT_LOGS_BY_DATE_RANGE_FAILURE
} from '../../types/csvImportLogs/csvImportLogsTypes';

const initialState = {
  // All logs
  allLogs: [],
  allLogsLoading: false,
  allLogsError: null,
  
  // Active logs
  activeLogs: [],
  activeLogsLoading: false,
  activeLogsError: null,
  
  // Single log
  currentLog: null,
  currentLogLoading: false,
  currentLogError: null,
  
  // Log by reference
  logByReference: null,
  logByReferenceLoading: false,
  logByReferenceError: null,
  
  // Create/Update/Delete operations
  operationLoading: false,
  operationError: null,
  operationSuccess: false,
  
  // Statistics
  stats: null,
  statsLoading: false,
  statsError: null,
  
  // Date range logs
  dateRangeLogs: [],
  dateRangeLogsLoading: false,
  dateRangeLogsError: null
};

const csvImportLogsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch all logs
    case FETCH_CSV_IMPORT_LOGS_REQUEST:
      return {
        ...state,
        allLogsLoading: true,
        allLogsError: null
      };
    case FETCH_CSV_IMPORT_LOGS_SUCCESS:
      return {
        ...state,
        allLogsLoading: false,
        allLogs: action.payload.data || [],
        allLogsError: null
      };
    case FETCH_CSV_IMPORT_LOGS_FAILURE:
      return {
        ...state,
        allLogsLoading: false,
        allLogsError: action.payload
      };

    // Fetch active logs
    case FETCH_ACTIVE_CSV_IMPORT_LOGS_REQUEST:
      return {
        ...state,
        activeLogsLoading: true,
        activeLogsError: null
      };
    case FETCH_ACTIVE_CSV_IMPORT_LOGS_SUCCESS:
      return {
        ...state,
        activeLogsLoading: false,
        activeLogs: action.payload.data || [],
        activeLogsError: null
      };
    case FETCH_ACTIVE_CSV_IMPORT_LOGS_FAILURE:
      return {
        ...state,
        activeLogsLoading: false,
        activeLogsError: action.payload
      };

    // Fetch log by ID
    case FETCH_CSV_IMPORT_LOG_BY_ID_REQUEST:
      return {
        ...state,
        currentLogLoading: true,
        currentLogError: null
      };
    case FETCH_CSV_IMPORT_LOG_BY_ID_SUCCESS:
      return {
        ...state,
        currentLogLoading: false,
        currentLog: action.payload.data,
        currentLogError: null
      };
    case FETCH_CSV_IMPORT_LOG_BY_ID_FAILURE:
      return {
        ...state,
        currentLogLoading: false,
        currentLogError: action.payload
      };

    // Fetch log by reference
    case FETCH_CSV_IMPORT_LOG_BY_REFERENCE_REQUEST:
      return {
        ...state,
        logByReferenceLoading: true,
        logByReferenceError: null
      };
    case FETCH_CSV_IMPORT_LOG_BY_REFERENCE_SUCCESS:
      return {
        ...state,
        logByReferenceLoading: false,
        logByReference: action.payload.data,
        logByReferenceError: null
      };
    case FETCH_CSV_IMPORT_LOG_BY_REFERENCE_FAILURE:
      return {
        ...state,
        logByReferenceLoading: false,
        logByReferenceError: action.payload
      };

    // Create log
    case CREATE_CSV_IMPORT_LOG_REQUEST:
      return {
        ...state,
        operationLoading: true,
        operationError: null,
        operationSuccess: false
      };
    case CREATE_CSV_IMPORT_LOG_SUCCESS:
      return {
        ...state,
        operationLoading: false,
        operationSuccess: true,
        operationError: null
      };
    case CREATE_CSV_IMPORT_LOG_FAILURE:
      return {
        ...state,
        operationLoading: false,
        operationError: action.payload,
        operationSuccess: false
      };

    // Update log
    case UPDATE_CSV_IMPORT_LOG_REQUEST:
      return {
        ...state,
        operationLoading: true,
        operationError: null,
        operationSuccess: false
      };
    case UPDATE_CSV_IMPORT_LOG_SUCCESS:
      return {
        ...state,
        operationLoading: false,
        operationSuccess: true,
        operationError: null
      };
    case UPDATE_CSV_IMPORT_LOG_FAILURE:
      return {
        ...state,
        operationLoading: false,
        operationError: action.payload,
        operationSuccess: false
      };

    // Update confirmation
    case UPDATE_CSV_IMPORT_LOG_CONFIRMATION_REQUEST:
      return {
        ...state,
        operationLoading: true,
        operationError: null,
        operationSuccess: false
      };
    case UPDATE_CSV_IMPORT_LOG_CONFIRMATION_SUCCESS:
      return {
        ...state,
        operationLoading: false,
        operationSuccess: true,
        operationError: null
      };
    case UPDATE_CSV_IMPORT_LOG_CONFIRMATION_FAILURE:
      return {
        ...state,
        operationLoading: false,
        operationError: action.payload,
        operationSuccess: false
      };

    // Delete log
    case DELETE_CSV_IMPORT_LOG_REQUEST:
      return {
        ...state,
        operationLoading: true,
        operationError: null,
        operationSuccess: false
      };
    case DELETE_CSV_IMPORT_LOG_SUCCESS:
      return {
        ...state,
        operationLoading: false,
        operationSuccess: true,
        operationError: null
      };
    case DELETE_CSV_IMPORT_LOG_FAILURE:
      return {
        ...state,
        operationLoading: false,
        operationError: action.payload,
        operationSuccess: false
      };

    // Fetch stats
    case FETCH_CSV_IMPORT_LOGS_STATS_REQUEST:
      return {
        ...state,
        statsLoading: true,
        statsError: null
      };
    case FETCH_CSV_IMPORT_LOGS_STATS_SUCCESS:
      return {
        ...state,
        statsLoading: false,
        stats: action.payload,
        statsError: null
      };
    case FETCH_CSV_IMPORT_LOGS_STATS_FAILURE:
      return {
        ...state,
        statsLoading: false,
        statsError: action.payload
      };

    // Fetch by date range
    case FETCH_CSV_IMPORT_LOGS_BY_DATE_RANGE_REQUEST:
      return {
        ...state,
        dateRangeLogsLoading: true,
        dateRangeLogsError: null
      };
    case FETCH_CSV_IMPORT_LOGS_BY_DATE_RANGE_SUCCESS:
      return {
        ...state,
        dateRangeLogsLoading: false,
        dateRangeLogs: action.payload.data || [],
        dateRangeLogsError: null
      };
    case FETCH_CSV_IMPORT_LOGS_BY_DATE_RANGE_FAILURE:
      return {
        ...state,
        dateRangeLogsLoading: false,
        dateRangeLogsError: action.payload
      };

    default:
      return state;
  }
};

export default csvImportLogsReducer; 